import { render, staticRenderFns } from "./apply-pass.vue?vue&type=template&id=46a785c0"
import script from "./apply-pass.vue?vue&type=script&lang=js"
export * from "./apply-pass.vue?vue&type=script&lang=js"
import style0 from "./apply-pass.vue?vue&type=style&index=0&id=46a785c0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a785c0')) {
      api.createRecord('46a785c0', component.options)
    } else {
      api.reload('46a785c0', component.options)
    }
    module.hot.accept("./apply-pass.vue?vue&type=template&id=46a785c0", function () {
      api.rerender('46a785c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/apply-pass.vue"
export default component.exports